import {Component, Input, OnInit} from '@angular/core';
import {G2Review, G2ReviewAnswer, G2ReviewAnswers} from '../../../models/g2-review.model';
import {WriteReviewDialogService} from '../write-review/write-review-dialog.service';

@Component({
  selector: 'dcp-review-answers',
  templateUrl: './review-answers.component.html',
  styleUrls: ['./review-answers.component.scss']
})
export class ReviewAnswersComponent implements OnInit {

  @Input() review: G2Review;
  @Input() reviewAnswerOrder: string[];
  reviewAnswers: G2ReviewAnswer[];

  constructor(
    public reviewModalService: WriteReviewDialogService) {
  }

  /**
   * Make sure that a certain order is kept by the answers, even when the backend doesn't contain the sorting data.
   *
   * @param reviewAnswerOrder passed into this component
   */
  static assureReviewAnswerOrder(reviewAnswerOrder: string[]) {
    if (!reviewAnswerOrder) {
      reviewAnswerOrder = ['love', 'hate', 'recommendations', 'benefits'];
    }
    return reviewAnswerOrder;
  }

  ngOnInit(): void {
    this.reviewAnswers = this.sortReviewAnswers(this.review.attributes.answers, this.reviewAnswerOrder);
  }

  /**
   *
   * @param answers answers that will be returned in a sorted order.
   * @param reviewAnswerOrder string array containing the keys of the answers.
   */
  sortReviewAnswers(answers: G2ReviewAnswers, reviewAnswerOrder: string[]): G2ReviewAnswer[] {
    reviewAnswerOrder = ReviewAnswersComponent.assureReviewAnswerOrder(reviewAnswerOrder);
    const sortedAnswers: G2ReviewAnswer[] = [];
    for (const answerKey of reviewAnswerOrder) {
      if (answers[answerKey]) {
        sortedAnswers.push(answers[answerKey]);
      }
    }
    return sortedAnswers;
  }
}
